import { useQuery } from "@tanstack/react-query";

import { getMyUser } from "@/api";

const useGetProfile = () => {
  return useQuery({
    queryKey: ["my-user"],
    queryFn: getMyUser,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    meta: {
      error: "Something went wrong... Try again",
    },
  });
};

export { useGetProfile };
